<content>
    <form [formGroup]="newFormSimple" [ngClass]="{'show-error':showError}" *ngIf="formVisible === 1">
        <div class="info">{{'global.infoRequired' | translate}}</div>
        <div class="entry-4-modal">
            <label>{{'mantenimientoConfecciones.confeccion.tipoConfeccion' | translate}} *</label>
            <app-filterable-list [itemsList]="tiposConfeccion" [selectedItem]="newFormSimple.get('tipoConfeccion')"
                [placeHolder]="false">
            </app-filterable-list>
        </div>
        <div class="entry-4-modal">
            <label>{{'mantenimientoConfecciones.confeccion.etiquetador' | translate}} *</label>
            <app-filterable-list [itemsList]="etiquetadores" [selectedItem]="newFormSimple.get('etiquetador')"
                [disabled]="disabledEtiquetador" [placeHolder]="false">
            </app-filterable-list>
        </div>
        <div class="entry-4-modal">
            <label>{{'mantenimientoConfecciones.confeccion.denominacion' | translate}} *</label>
            <app-filterable-list [itemsList]="denominaciones" [selectedItem]="newFormSimple.get('denominacion')"
                [disabled]="disabledDenominaciones" [placeHolder]="false">
            </app-filterable-list>
        </div>
        <div class="entry-4-modal">
            <label>{{'mantenimientoConfecciones.confeccion.confeccion' | translate}} *</label>
            <input type="text" formControlName="des">
        </div>
        <div class="entry-4-modal">
            <label>{{'mantenimientoConfecciones.confeccion.alias' | translate}}</label>
            <input type="text" formControlName="alias">
        </div>
        <div class="entry-4-modal" *ngIf="tipoConfeccion === 2">
            <label>{{'mantenimientoConfecciones.confeccion.nCajas' | translate}} *</label>
            <input type="number" min="1" value="1" formControlName="numCajas">
        </div>
        <div class="entry-4-modal">
            <label>{{'mantenimientoConfecciones.confeccion.pesoCaja' | translate}} *</label>
            <input type="number" formControlName="kilos">
        </div>
        <div class="entry-4-modal">
            <label>{{'mantenimientoConfecciones.confeccion.unidadMedida' | translate}} *</label>
            <app-filterable-list [itemsList]="unidadesMedida" [selectedItem]="newFormSimple.get('unidadMedida')"
                [disabled]="disabledUnidadMedida" [placeHolder]="false">
            </app-filterable-list>
        </div>
        <div class="entry-4-modal">
            <label>{{'mantenimientoConfecciones.confeccion.envase' | translate}}</label>
            <app-filterable-list class="shorter-list" [itemsList]="envases" [selectedItem]="newFormSimple.get('envase')"
                [disabled]="disabledEnvases" [placeHolder]="false">
            </app-filterable-list>
        </div>
        <div class="entry-4-modal">
            <label>{{'mantenimientoConfecciones.confeccion.pesoEnvase' | translate}}</label>
            <input type="number" formControlName="pesoEnvase">
        </div>
        <div class="entry-4-modal">
            <label>{{'mantenimientoConfecciones.confeccion.nEnvasesCaja' | translate}}</label>
            <input type="number" formControlName="numeroEnvasesCaja">
        </div>
    </form>
    <section class="filters-framed" *ngIf="formVisible === 2">
        <form [formGroup]="newFormCompleta">
            <div class="entry-4-modal">
                <label>{{'mantenimientoConfecciones.confeccion.confeccion' | translate}} *</label>
                <input type="text" readonly formControlName="des">
            </div>
            <div class="entry-4-modal">
                <label>{{'mantenimientoConfecciones.confeccion.alias' | translate}}</label>
                <input type="text" readonly formControlName="alias">
            </div>
            <div class="entry-4-modal">
                <label>{{'mantenimientoConfecciones.confeccion.etiquetador' | translate}} *</label>
                <app-filterable-list [itemsList]="etiquetadores" [selectedItem]="newFormCompleta.get('etiquetador')"
                    [disabled]="disabledForm" [placeHolder]="false"></app-filterable-list>
            </div>
            <div class="entry-4-modal">
                <label>{{'mantenimientoConfecciones.confeccion.denominacion' | translate}} *</label>
                <app-filterable-list [itemsList]="denominaciones" [selectedItem]="newFormCompleta.get('denominacion')"
                    [disabled]="disabledDenominaciones" [placeHolder]="false"></app-filterable-list>
            </div>
            <div class="entry-5-modal">
                <label>{{'mantenimientoConfecciones.confeccion.tipoConfeccion'| translate}} *</label>
                <app-filterable-list [itemsList]="tiposConfeccion"
                    [selectedItem]="newFormCompleta.get('tipoConfeccion')" [disabled]="disabledForm"
                    [placeHolder]="false"></app-filterable-list>
            </div>
            <div class="entry-5-modal" *ngIf="tipoConfeccion === 2">
                <label>{{'mantenimientoConfecciones.confeccion.nCajas' | translate}}</label>
                <input type="number" min="1" value="numCajas" formControlName="numCajas">
            </div>
            <div class="entry-5-modal">
                <label>{{'mantenimientoConfecciones.confeccion.unidadMedida' | translate}} *</label>
                <app-filterable-list [itemsList]="unidadesMedida" [selectedItem]="newFormCompleta.get('unidadMedida')"
                    [disabled]="disabledForm" [placeHolder]="false"></app-filterable-list>
            </div>
            <div class="entry-5-modal">
                <label>{{'mantenimientoConfecciones.confeccion.pesoCaja' | translate}}</label>
                <input type="text" readonly formControlName="kilos">
            </div>
            <div class="entry-5-modal">
                <label>{{'mantenimientoConfecciones.confeccion.envase' | translate}}</label>
                <app-filterable-list [itemsList]="envases" [selectedItem]="newFormCompleta.get('envase')"
                    [disabled]="disabledEnvases" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div class="entry-5-modal">
                <label>{{'mantenimientoConfecciones.confeccion.nEnvasesCaja' | translate}}</label>
                <input type="text" readonly formControlName="numeroEnvasesCaja">
            </div>
            <div class="entry-5-modal" *ngIf="tipoConfeccion === 2">
                <label>{{'mantenimientoConfecciones.confeccion.pesoPallet' | translate}}</label>
                <input type="text" readonly formControlName="pesoPallet">
            </div>

        </form>
    </section>
    <div class="table-modal" *ngIf="formVisible === 2">
        <h4><span class="underline">{{'mantenimientoConfecciones.confeccion.envasesConfeccion.tituloParte1' |
                translate}}</span>{{'mantenimientoConfecciones.confeccion.envasesConfeccion.tituloParte2' |
            translate}}<span>{{'mantenimientoConfecciones.confeccion.envasesConfeccion.tituloParte3' |
                translate}}</span>{{'mantenimientoConfecciones.confeccion.envasesConfeccion.tituloParte4' | translate}}
        </h4>
        <div class="table-wrapper-bigger">
            <div class="table-container">
                <table>
                    <thead>
                        <tr>
                            <th>{{'mantenimientoConfecciones.confeccion.envasesConfeccion.id' | translate}}</th>
                            <th>{{'mantenimientoConfecciones.confeccion.envasesConfeccion.envase' | translate}}</th>
                            <th>{{'mantenimientoConfecciones.confeccion.envasesConfeccion.peso' | translate}}</th>
                            <th>{{'mantenimientoConfecciones.confeccion.envasesConfeccion.nEnvasesCaja' | translate}}</th>
                            <th class="action">
                                <i class="fas fa-plus" (click)="addNewEnvases()"
                                    title="{{'mantenimientoConfecciones.tituloNew' | translate}}"></i>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <app-envases-porcion-component class="component-in-row" *ngIf="newEnvases" [editable]="true"
                            [allEnvases]="envases" [idTabla]="idTabla" (close)="newEnvases=$event"
                            (refreshAdd)="refreshAddEnvases($event)">
                        </app-envases-porcion-component>
                        <app-envases-porcion-component class="component-in-row" *ngFor="let envasePorciones of envasesPorciones"
                            [allEnvases]="envases" [envase]="envasePorciones" [editable]="false" [idTabla]="idTabla"
                            (refreshRemove)="refreshRemoveEnvases($event)">
                        </app-envases-porcion-component>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="table-modal" *ngIf="formVisible === 2">
        <h4><span class="underline">{{'mantenimientoConfecciones.confeccion.porcionesConfeccion.tituloParte1' |
                translate}}</span>{{'mantenimientoConfecciones.confeccion.porcionesConfeccion.tituloParte2' |
            translate}}<span>{{'mantenimientoConfecciones.confeccion.porcionesConfeccion.tituloParte3' |
                translate}}</span>{{'mantenimientoConfecciones.confeccion.porcionesConfeccion.tituloParte4' |
            translate}}<span>{{'mantenimientoConfecciones.confeccion.porcionesConfeccion.tituloParte5' |
                translate}}</span>{{'mantenimientoConfecciones.confeccion.porcionesConfeccion.tituloParte6' |
            translate}}<span>{{'mantenimientoConfecciones.confeccion.porcionesConfeccion.tituloParte7' |
                translate}}</span>{{'mantenimientoConfecciones.confeccion.porcionesConfeccion.tituloParte8' |
            translate}}<span
                class="only-underline">{{'mantenimientoConfecciones.confeccion.porcionesConfeccion.tituloParte9' |
                translate}}</span>{{'mantenimientoConfecciones.confeccion.porcionesConfeccion.tituloParte10' |
            translate}}</h4>
        <div class="table-wrapper-bigger">
            <div class="table-container">
                <table>
                    <thead>
                        <tr>
                            <th>{{'mantenimientoConfecciones.confeccion.porcionesConfeccion.envase' | translate}}</th>
                            <th>{{'mantenimientoConfecciones.confeccion.porcionesConfeccion.denominacion' | translate}}</th>
                            <th>{{'mantenimientoConfecciones.confeccion.porcionesConfeccion.pesoPorcion' | translate}}</th>
                            <th class="action">
                                <i class="fas fa-plus" *ngIf="envasesPorciones.length > 0" (click)="addNewPorciones()"></i>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <app-proporciones-envase-component class="component-in-row" *ngIf="newPorciones" [editable]="true"
                            [porciones]="porciones" [denominaciones]="denominacionesEnvases" [envases]="envasesPorcionesId"
                            (close)="newPorciones=$event" (refreshAdd)="refreshAddPorcionesEnvase($event)">
                        </app-proporciones-envase-component>
                        <app-proporciones-envase-component class="component-in-row" *ngFor="let porcion of porciones"
                            [porcion]="porcion" [editable]="false" [denominaciones]="denominacionesEnvases"
                            [envases]="envasesPorcionesId" (refreshRemove)="refreshRemovePorcionesEnvase($event)">
                        </app-proporciones-envase-component>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</content>
<footer class="button-bar-right">
    <button class="secondary" [ngClass]="{'secondary-disabled': disabledButtonAvanzada}" *ngIf="formVisible === 1"
        (click)="showSimpleModal()"
        [disabled]="disabledButtonAvanzada">{{'mantenimientoConfecciones.confeccion.modalAvanzada.titulo' |
        translate}}</button>
    <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
    <button [ngClass]="{'disabled': disabledButtonInsertar}" *ngIf="showSiguiente" (click)="changeSiguiente()"
        [disabled]="disabledButtonInsertar">{{'global.siguiente' | translate}}</button>
    <button [ngClass]="{'disabled': disabledButtonInsertar}" *ngIf="!showSiguiente"
        (click)="formVisible === 1? addSimple() : addCompleta()" [disabled]="disabledButtonInsertar">{{'global.insertar'
        |
        translate}}</button>
</footer>
<app-toast *ngIf="(showError || showWarning) && mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>
<div class="modal" *ngIf="simpleModal">
    <div class="modal-content">
        <header>
            <h4>{{'mantenimientoConfecciones.confeccion.modalAvanzada.titulo' | translate}}</h4>
        </header>
        <content class="multiple-actions">
            <p [innerHTML]="'mantenimientoConfecciones.confeccion.modalAvanzada.parte1' | translate"></p>
            <ul>
                <li [innerHTML]="'mantenimientoConfecciones.confeccion.modalAvanzada.lista1' | translate"></li>
                <li [innerHTML]="'mantenimientoConfecciones.confeccion.modalAvanzada.lista2' | translate"></li>
                <li [innerHTML]="'mantenimientoConfecciones.confeccion.modalAvanzada.lista3' | translate"></li>
            </ul>
            <p>{{'mantenimientoConfecciones.confeccion.modalAvanzada.parte2' | translate}}</p>
        </content>
        <footer>
            <button class="secondary" (click)="changeForm()">{{'global.si' | translate}}</button>
            <button (click)="simpleModal = false">{{'global.no' | translate}}</button>
        </footer>
    </div>
</div>
<div class="modal" *ngIf="resumenModal">
    <div class="modal-content">
        <header>
            <h4>Confección Completa</h4>
        </header>
        <content>
            <h4>Se va ha insertar una confección con los siguientes datos: </h4>
            <p> Confección: {{this.newFormCompleta.get('des').value}}</p>
            <p>Etiquetador: {{this.newFormCompleta.get('etiquetador').value.des}}</p>
            <p>Caja: prueba</p>
            <p>Envases:</p>
        </content>
        <footer>
            <button class="secondary" (click)="resumenModal = false">{{'global.cancelar' | translate}}</button>
            <button (click)="addCompleta()">{{'global.confirmar' | translate}}</button>
        </footer>
    </div>
</div>